module.exports = __webpack_public_path__ + "img/battery_1green.b4e1fd2c.png";